module.exports = __webpack_public_path__ + "static/media/quartz-ust.2836a934.svg";